
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subsets/icdom-subsets",
      function () {
        return require("private-next-pages/subsets/icdom-subsets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subsets/icdom-subsets"])
      });
    }
  